// extracted by mini-css-extract-plugin
export default {"barchart":"BarChart_barchart__LmunH"};